module.exports = __webpack_public_path__ + "img/396.bf2ea39b.jpg";